<template>
  <div>
    <multiselect
      v-model="value"
      :options="options"
      searchable="true"
      placeholder="Select Company"
      @change="onChange($event)"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import api from "@/api/index";
import { mapState } from "vuex";

export default {
  components: {
    Multiselect,
  },
  props: {
    companyData: {
      type: Object,
    },
  },
  data() {
    return {
      value: null,
      companies: [],
      groups: [],
    };
  },
  watch: {
    company() {
      this.getCompanies();
    },
    companyData(value) {
      this.value = value;
    },
  },
  computed: {
    ...mapState({
      company: (state) => state.auth.company,
    }),
    options() {
      return this.companies.map((f) => {
        return {
          label: f.companyName,
          value: { label: f.companyName, value: f.companyGuid },
        };
      });
    },
  },
  methods: {
    async getCompanies() {
      const res = await api.companies.get();
      this.companies = res.data.entityData;
    },
    onChange(e) {
      this.$emit("change", e);
    },
  },
  async created() {
    await this.getCompanies();
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="scss" scoped></style>
